
define([
    'core/uploader',
    'core/logo-repository',
    "components/modal",
    'core/browser-storage',
    'core/iterate',
    'core/constants',
    'moment',
], function(
    uploader, 
    logo_repository, 
    modal, 
    storage,
    iterate,
    constants,
    moment
) {

    let utilities = {
        addCharacterCount: (inputSelector, limit) => {
            let input = document.querySelector(inputSelector);
            if (!input) return;

            let currentLength = input.value.length;

            input.insertAdjacentHTML('afterend', `<div data-limit="${limit}" class="char-count"><span class="current">${currentLength}</span> / ${limit}</div>`);
            let limitMet = false;

            let execution = (event) => {
                currentLength = event.target.value.length;
                let countEl = input.parentNode.querySelector(".char-count");
                let countSpan = countEl.querySelector(".current");

                countSpan.innerText = currentLength;

                if (currentLength > limit) {
                    countEl.classList.add("error");
                    input.classList.add("danger");
                    limitMet = true;
                    return;
                }

                if (limitMet && currentLength <= limit) {
                    countEl.classList.remove("error");
                    input.classList.remove("danger");
                    limitMet = false;
                }
            }

            input.addEventListener("keyup", execution);
            input.addEventListener("click", execution);
        },
        htmlToText: (html) => {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            return temp.textContent.trim(); 
        },
        validateForm: (configArray, wrapperElement) => {
            /*
            accepts array of configs for each input:
                [
                    {
                        input: element being validated,
                        errorNode: error element associated with input,
                        validations: array of checks to perform on input (eg: ["hasValue", "notTooLong",])
                    },
                    ...
                ]

            wrapperElement is optional. Allows you to add scope to which errors you are validating

            function returns True or False if form is valid
            */
            let configs = configArray;
            let isValid = true;

            let visibleErrors = document.querySelectorAll(".error.input-error:not(.hide)");

            if (visibleErrors) {
                visibleErrors.forEach(error => {
                    error.classList.add("emphasis");

                    setTimeout(() => {
                        error.classList.remove("emphasis");
                    }, 300)
                })
            }

            let getSelectizeInputElement = (input) => {
                return input.parentElement?.querySelector(".selectize-input")
                    || input.closest(".selectize-control")?.querySelector(".selectize-input");
            };

            let inputHasValue = (input) => {
                if (input.selectize) {
                    const value = input.selectize.getValue();
                    return Array.isArray(value) ? value.length > 0 : Boolean(value);
                }

                return input.value.trim().length > 0
                    && input.value.trim() !== '<p><br></p>'
                    && input.value.trim() !== '<p> </p>';
            };

            let checkCurrentlyValid = (input, errorNode, currentlyValid) => {
                errorNode.classList.add("hide");
                input.classList.remove("error");

                let quillElement = input.parentElement.querySelector(".ql-editor");
                if(quillElement) quillElement.classList.remove("danger");

                let selectizeElement = getSelectizeInputElement(input);
                if(selectizeElement) selectizeElement.classList.remove("danger");

                if (!currentlyValid) {
                    errorNode.classList.remove("hide");
                    input.classList.add("error");
                    if(quillElement) quillElement.classList.add("danger");
                    if(selectizeElement) selectizeElement.classList.add("danger");
                }

                const clearValidationError = () => {
                    errorNode.classList.add("hide");
                    input.classList.remove("error");
                    const selectizeEl = getSelectizeInputElement(input);
                    if (selectizeEl) selectizeEl.classList.remove("danger");
                };

                if (!input.dataset.validationClearListener) {
                    input.dataset.validationClearListener = "true";

                    if (input.type === "textarea" || input.type === "text") {
                        input.addEventListener("keyup", clearValidationError);
                    } else if (input.selectize) {
                        input.selectize.on("change", clearValidationError);
                    } else if (input.multiple) {
                        input.addEventListener("change", clearValidationError);
                    }
                }
            }

            let validationCheck = {
                hasValue: (input, errorNode, currentlyValid) => {
                    checkCurrentlyValid(input, errorNode, currentlyValid);

                    if (!inputHasValue(input)) {
                        isValid = false;
                        errorNode.innerText = "Please enter a value";
                        errorNode.classList.remove("hide");
                        input.classList.add("error");

                        let quillElement = input.parentElement.querySelector(".ql-editor");
                        if(quillElement) quillElement.classList.add("danger");

                        let selectizeElement = getSelectizeInputElement(input);
                        if(selectizeElement) selectizeElement.classList.add("danger");
                        return false;
                    }

                    if (currentlyValid)
                        return true;
                    else {
                        return false;
                    }
                },
                passwordsMatch: (input, errorNode, currentlyValid, input2) => {
                    checkCurrentlyValid(input, errorNode, currentlyValid);

                    if (input.value.trim() !== input2.value.trim()) {
                        isValid = false;
                        errorNode.innerText = "Passwords do not match";
                        errorNode.classList.remove("hide");
                        input.classList.add("error");
                        return false;
                    }

                    if (currentlyValid)
                        return true;
                    else {
                        return false;
                    }
                },
                emailNameAddress: (input, errorNode, currentlyValid) => {
                    // for checking "name" portion of email address
                    // ex: john@outlook.com
                    // regex is used for checking "john"
                    checkCurrentlyValid(input, errorNode, currentlyValid);

                    let regex = /^[A-Za-z0-9_./+-]*$/;
                    if (!regex.test(input.value)) {
                        isValid = false;
                        errorNode.innerText = "Invalid characters";
                        errorNode.classList.remove("hide");
                        input.classList.add("error");
                        return false;
                    }

                    if (currentlyValid)
                        return true;
                    else {
                        return false;
                    }
                },
                alphaNumeric: (input, errorNode, currentlyValid) => {
                    checkCurrentlyValid(input, errorNode, currentlyValid);

                    let regex = /^[ A-Za-z0-9_@./#'&+-]*$/;
                    if (!regex.test(input.value)) {
                        isValid = false;
                        errorNode.innerText = "Invalid characters";
                        errorNode.classList.remove("hide");
                        input.classList.add("error");
                        return false;
                    }

                    if (currentlyValid)
                        return true;
                    else {
                        return false;
                    }
                },
                alphaNumericReduced: (input, errorNode, currentlyValid) => {
                    checkCurrentlyValid(input, errorNode, currentlyValid);

                    let regex = /^[ A-Za-z0-9_./+-]*$/;
                    if (!regex.test(input.value)) {
                        isValid = false;
                        errorNode.innerText = "Please use alpha-numeric characters only";
                        errorNode.classList.remove("hide");
                        input.classList.add("error");
                        return false;
                    }

                    if (currentlyValid)
                        return true;
                    else {
                        return false;
                    }
                },
                email: (input, errorNode, currentlyValid) => {
                    checkCurrentlyValid(input, errorNode, currentlyValid);

                    let regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
                    if (!regex.test(input.value)) {
                        isValid = false;
                        errorNode.innerText = "Invalid email";
                        errorNode.classList.remove("hide");
                        input.classList.add("error");
                        return false;
                    }

                    if (currentlyValid)
                        return true;
                    else {
                        return false;
                    }
                },
                isValidURL: (input, errorNode, currentlyValid) => {
                    checkCurrentlyValid(input, errorNode, currentlyValid);

                    let regex = /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{0,256}\.[a-z]{1,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/=]*)$/;
                    if (!regex.test(input.value)) {
                        isValid = false;
                        errorNode.innerText = "Please enter a valid URL (including https://)";
                        errorNode.classList.remove("hide");
                        input.classList.add("error");
                        return false;
                    }

                    if (currentlyValid)
                        return true;
                    else {
                        return false;
                    }
                },
                notTooLong: (input, errorNode, currentlyValid) => {
                    checkCurrentlyValid(input, errorNode, currentlyValid, "not too long");

                    let limit = input.parentElement.querySelector(".char-count").getAttribute("data-limit");

                    if (input.value.length > limit) {
                        isValid = false;
                        errorNode.innerText = `Please limit this field to ${limit} characters`;
                        errorNode.classList.remove("hide");
                        input.classList.add("error");
                        return false;
                    }
                    if (currentlyValid)
                        return true;
                    else {
                        return false;
                    }
                },
                notTooLongHTML: (input, errorNode, currentlyValid) => {
                    checkCurrentlyValid(input, errorNode, currentlyValid, "not too long");

                    let limit = input.parentElement.querySelector(".char-count").getAttribute("data-limit");

                    if (utilities.htmlToText(input.value).length > limit) {
                        isValid = false;
                        errorNode.innerText = `Please limit this field to ${limit} characters`;
                        errorNode.classList.remove("hide");
                        input.classList.add("error");

                        let quillElement = input.parentElement.querySelector(".ql-editor");
                        if(quillElement) quillElement.classList.add("danger");
                        
                        return false;
                    }
                    if (currentlyValid)
                        return true;
                    else {
                        return false;
                    }
                },
                noRepeatQuestions: (questions, errorNode, currentlyValid) => {
                    // for project survey step 3        
                    selectedQuestions = [];
                    let returnValue = true;
                    let questionWrap = questions[0].parentElement;

                    errorNode.classList.add("hide");
                    questionWrap.classList.remove("error");

                    questions.forEach(question => {
                        if (!question.classList.contains("hide")) {
                            let selectedValue = question.querySelector(".mock-select").innerText;

                            if (selectedQuestions.indexOf(selectedValue) < 0) {
                                // question hasn't been selected yet - add it to array
                                selectedQuestions.push(selectedValue);
                            } else {
                                isValid = false;
                                errorNode.innerText = 'You have duplicated survey questions. Please remove duplicates.';
                                errorNode.classList.remove("hide");
                                questionWrap.classList.add("error");
                                returnValue = false;
                            }
                        }
                    })

                    return returnValue;
                },
                hasSelectedCheckbox: (wrapper, errorNode, currentlyValid) => {
                    checkCurrentlyValid(wrapper, errorNode, currentlyValid);
                    // for project survey step 3        
                    selectedQuestions = [];
                    let returnValue = false;
                    let checkBoxes = wrapper.querySelectorAll("input[type='checkbox']");

                    errorNode.classList.add("hide");

                    checkBoxes.forEach(checkBox => {
                        if (checkBox.checked) {
                            returnValue = true;
                        }
                    });

                    if (!returnValue) {
                        isValid = false;
                        errorNode.innerText = 'Please select at least one option.';
                        errorNode.classList.remove("hide");
                    }

                    return returnValue;
                }                
            }

            configs.forEach((config) => {
                if(config.input.disabled) return;
                config.isCurrentlyValid = true;
                config.validations.forEach(validation => {
                    let newState = validationCheck[validation](config.input, config.errorNode, config.isCurrentlyValid, config.input2);
                    config.isCurrentlyValid = newState;
                })
            })

            // scroll to first error
            if (!isValid) {
                let errors = wrapperElement ? wrapperElement.querySelectorAll(".input-error") : document.querySelectorAll(".input-error");
                for (const element of errors) {
                    if (!element.classList.contains("hide")) {
                        element.parentElement.scrollIntoView();
                        break;
                    }
                }
            }

            return isValid;
        },
        updateDateStatus: (dateParams, dateStatusNode, includeFrom) => {
            let fromText = includeFrom ? "From " : "";

            let defaultDateParams = {
                preset: 'Last 90 days',
                date: [
                    moment().subtract(90, 'days'),
                    moment()
                ]
            };

            if(!dateParams) dateParams = defaultDateParams;
            let dateParamOutput = "";
            if(dateParams.preset) {
                dateParamOutput = includeFrom ? dateParams.preset.toLowerCase() : dateParams.preset;
            }

            let status = dateParams.preset ? dateParamOutput : `${moment(dateParams.date[0]).format('MMM DD, YYYY')} - ${moment(dateParams.date[1]).format('MMM DD, YYYY')}`;
            dateStatusNode.innerText = `${fromText} ${status}`;
        },
        // display filter status at top of section in plain english
        updateFilterStatus: (queryParams, cb) => {
            let filterCount = 0;
            let categories = [];
            let filterStatus = document.querySelector(".filter-status");

            iterate(queryParams, (value, key) => {
                if(Array.isArray(value)) {
                    if(value.length) {
                        filterCount += value.length;
                        categories.push(constants.filterNameMapping[key].singular);
                    }
                } else {
                    //boolean filter
                    if(JSON.stringify(value) === "true" || JSON.stringify(value) === "false") {
                        filterCount ++;
                        categories.push(constants.filterNameMapping[key].singular);
                    }

                    // comment is a radio selection - if anything but 0 / "" / "all" is selected, it is considered filtered
                    if((key === 'comments' || key === 'comment') && value !== "" && value !== "0" && value !== 0 && value !== 'all') {
                        filterCount ++;
                        categories.push(constants.filterNameMapping[key].singular);
                    }
                }
            })

            let message = "No filters selected";

            if(filterCount > 0) {
                let buildCategoryGrammar = () => {
                    if(categories.length === 1) return `<strong>${categories.toString()}</strong>`;
                    
                    let oxfordComma = categories.length === 2 ? ' ' : ', ';
                    let lastCategory = categories.pop();
                    return `<strong>${categories.join('</strong>, <strong>')}</strong>${oxfordComma}and <strong>${lastCategory}</strong>`;
                }
                
                let categoryText = categories.length < 4 ? buildCategoryGrammar() : `<strong>${categories.length} categories</strong>`
                let filterText = filterCount > 1 ? 'filters' : 'filter';

                message = `<strong>${filterCount}</strong> active ${filterText} in ${categoryText}`

                filterStatus.classList.add("active")
            } else {
                filterStatus.classList.remove("active")
            }

            filterStatus.innerHTML = message;

            if(cb) cb();
        },
        setSettingsHeight: (nodes, isPageLoad) => {
            let isHidden = nodes.settingsPanel.classList.contains("hide");
            //disable transitions while adjusting height value
            nodes.settingsPanel.classList.add("no-transition");
            // momentarily show and save settings height so hide transition works
            nodes.settingsPanel.classList.remove("hide");
            nodes.settingsPanel.style.height = null;
            let settingsHeight = nodes.settingsPanel.offsetHeight;
            nodes.settingsPanel.style.height = `${settingsHeight}px`;
        
            if(isPageLoad || isHidden) { // don't override user's open/close settings
                nodes.settingsPanel.classList.add("hide");
            }
                
            setTimeout(() => {
                nodes.settingsPanel.classList.remove("no-transition");
            }, 100);
        },
        // for displaying an exit confirmation modal when clicking away form current page
        confirmPageExit: (event, createdModal, modalTemplate, customMessage, hrefsToIgnore, callback) => {
            let target = event.currentTarget;

            let href = target.getAttribute("href").trim();
            let hint = target.getAttribute("target");

            if (hrefsToIgnore && hrefsToIgnore.indexOf(target.pathname.trim()) > -1) return;

            if (href !== window.location.pathname && href !== "#" && hint !== "_blank") {

                if (customMessage) {
                    modalTemplate.querySelector(".confirm-msg_js b").innerText = customMessage;
                }

                createdModal.open(null, function (el) {
                    const exitButton = el.querySelector(".exit");
                    exitButton.setAttribute("href", href);

                    if (callback) {
                        callback(el, href);
                    }
                }, modalTemplate);

                event.preventDefault();


            }
        },
        enableInputResets: () => {
            let resetButtons = document.querySelectorAll(".reset-input");

            resetButtons.forEach(resetButton => {
                if (resetButton.classList.contains("manual")) return;

                resetButton.addEventListener("click", () => {
                    let input = resetButton.parentElement.querySelector('textarea');
                    if (!input) {
                        input = resetButton.parentElement.querySelector('input');
                    }

                    input.value = input.getAttribute("data-default");

                    if (input.name === 'color') {
                        setDefaultColor();
                    }

                    resetButton.classList.add("roll");

                    setTimeout(() => {
                        resetButton.classList.remove("roll");
                    }, 300);
                })
            })
        },
        enableLogoPicker: (
            modalNodes, 
            onChange, // optional
            logoInputId // optional - if not provided, defaults to "id_logo"
        ) => {
            let nodes = {
                imgPreview: {
                    withLogo: document.querySelector(".conf-mail-withlogo_js"),
                    noLogo: document.querySelector(".conf-mail-nologo_js"),
                    controls: document.querySelector(".conf-mail-upload-ctrl_js"),
                    openBtn: document.querySelector(".uploader-open_js"),
                    minusLogo: document.querySelector(".uploader-delete-logo_js")
                },
                logoPicker: document.querySelector(".logo-picker_js"),
                modalUploadLogoContent: document.querySelector('.modal-template-upload_js'),
                progress: document.querySelector(".new-progress"),
                getLogosContainer: function () {
                    return document.querySelector(".modal-template-upload_js .logos_js")
                },
                modal: modalNodes
            }

            let logoInputIdSelector = logoInputId ? `#${logoInputId}` : "#id_logo";

            let createdModal = modal.create(nodes.modal, function (el) {
            });

            let progress = (function () {
                let p = nodes.progress;
                p.classList.add("disabled");
                return {
                    start: function () {
                        p.classList.remove("disabled");
                    },
                    stop: function () {
                        p.classList.add("disabled");
                    }
                }
            })();

            let openUploadModal = (uploadcare) => {
                let onUpload = (fileInfo) => {
                    logo_repository
                    .LogoRepository
                    .save(fileInfo.uuid)
                    .done(function (logo) {
                        let img = {
                            title: logo.title,
                            id: logo.id,
                            src: logo.resource_thumbnail,
                        };

                        imageWorker.set(img);
                        addImgToList(nodes.getLogosContainer(), img);
                        addImgToPreview(nodes.imgPreview, img);
                        waitImg(logo.resource_thumbnail, function () {
                            showPreview(nodes.imgPreview);
                            progress.stop();
                        })
                    });

                    progress.stop();
                };

                createdModal.open(null, function (el) {
                    let btn = el.querySelector(".upload-care_js");

                    btn.addEventListener("click", function () {
                        let dialog = uploadcare.openDialog(null, {
                            validators: [
                                uploader.maxSizeValidator(window.UPLOADCARE_FILE_MAX_MB * 1024 * 1024),
                                uploader.fileTypeValidator('png jpeg jpg gif')
                            ]
                        });

                        dialog.done(function imageUploaded(result) {

                            createdModal.close();
                            progress.start();

                            result.always((data, dataFull) => {
                                if((!dataFull && !data.isImage) || (dataFull && !dataFull.isImage)) {
                                    // uploadError(data);
                                    console.log('not an image');
                                    progress.stop();
                                } else if(dataFull && dataFull.sourceInfo.source === "url-tab") {
                                    onUpload(dataFull);
                                }
                            })

                            result.done(function (fileInfo) {
                                onUpload(fileInfo)
                            });

                        }).fail(function () {
                            nodes.imgPreview.noLogo.classList.remove("disabled");
                            progress.stop();
                        });

                    });

                    var logosWrapper = el.querySelector(".logos_js");

                    function onLogoClick(e) {

                        var image = {};
                        var target = e.target;
                        var id = target.getAttribute("data-id");

                        if (!id) {
                            return
                        }

                        image.id = id;
                        image.src = target.getAttribute("data-src");
                        image.title = target.getAttribute("data-title");

                        addImgToPreview(nodes.imgPreview, image);

                        imageWorker.set(image);

                        showPreview(nodes.imgPreview);

                        createdModal.close(function () {
                            logosWrapper.removeEventListener("click", onLogoClick);
                        });

                    }

                    let showMoreButton = el.querySelector(".show-more_js");

                    function showAllLogos() {
                        let hiddenLogos = el.querySelectorAll(".logo-item_js.hide-mobile");
                        hiddenLogos.forEach(logo => {
                            logo.classList.remove("hide-mobile");
                        });
                        showMoreButton.innerText = "Close"
                        showMoreButton.removeEventListener("click", showAllLogos);
                        showMoreButton.addEventListener("click", () => createdModal.close());
                    }

                    logosWrapper.addEventListener("click", onLogoClick);
                    el.querySelector(".modal-close_js").addEventListener("click", () => {
                        createdModal.close();
                    });
                    showMoreButton.addEventListener("click", showAllLogos);

                }, nodes.modalUploadLogoContent)

            }

            let imageWorker = {
                set: function (img) {
                    this.image = img
                },
                save: function () {
                    storage.addObj("conf-email-img", this.image || {
                        id: "",
                        title: "",
                        src: ""
                    });
                },
                get: function () {
                    return this.image
                },
                remove: function () {
                    storage.removeItem("conf-email-img");
                }
            };

            function addImgToList(wrap, imageData) {

                let div = document.createElement("div");
                div.style.backgroundImage = "url('" + imageData.src + "')";

                ['id', "title", "src"].forEach(function (key) {
                    div.setAttribute("data-" + key, imageData[key]);
                });

                div.classList.add("sb-modal-upload__select-item");
                div.classList.add("logo-item_js");

                div.setAttribute("alt", imageData.title);
                wrap.prepend(div);

            }

            let waitImg = (src, onLoaded) => {
                var preloaderImg = document.createElement("img");
                preloaderImg.src = src;
                preloaderImg.addEventListener('load', (event) => {
                    preloaderImg = null;
                    onLoaded();
                });
            }

            let addImgToPreview = (imageContainer, img) => {
                setImgId(img.id);
                imageContainer.withLogo.style.backgroundImage = 'url(' + img.src + ')';
                imageContainer.withLogo.setAttribute('alt', img.name);
                ['id', "uuid"].forEach(function (key) {
                    imageContainer.withLogo.setAttribute('data' + key, img[key]);
                });
            }

            let setImgId = (id) => {
                document.querySelector(logoInputIdSelector).value = id;
            }

            let removeImgId = () => {
                document.querySelector(logoInputIdSelector).value = "";
                imageWorker.remove();
            }

            let showPreview = (nodes) => {
                nodes.controls.classList.remove("disabled");
                nodes.noLogo.classList.add("disabled");
                nodes.withLogo.classList.remove("disabled");
                if(onChange) onChange();
            }

            let hidePreview = (nodes) => {
                removeImgId();
                nodes.controls.classList.add("disabled");
                nodes.noLogo.classList.remove("disabled");
                nodes.withLogo.classList.add("disabled");
                if(onChange) onChange();
            }

            let setImg = (image) => {
                imageWorker.set(image);
                addImgToPreview(nodes.imgPreview, image);
                if (image.id)
                    showPreview(nodes.imgPreview, image);
            }

            let setDefaultLogo = () => {
                let imgID = document.querySelector(logoInputIdSelector).value;
                let imgElement = document.querySelector(`.logo-item_js[data-id="${imgID}"]`);

                if (!imgElement) return;

                let imgConfig = {
                    title: imgElement.getAttribute("data-title"),
                    id: imgID,
                    src: imgElement.getAttribute("data-src"),
                }

                setImg(imgConfig);
            }

            let uploaderCallback = (uploadcare) => {
                nodes.logoPicker.addEventListener("dragover", function (e) {
                    nodes.logoPicker.classList.add("dragover");
                });

                nodes.logoPicker.addEventListener("click", function (e) {
                    openUploadModal(uploadcare);
                });

                nodes.logoPicker.addEventListener("dragleave", function (e) {
                    nodes.logoPicker.classList.remove("dragover");
                });

                uploadcare.dragdrop.uploadDrop(nodes.logoPicker, function (file) {

                    nodes.logoPicker.classList.remove("dragover");
                    progress.start();

                    file.done(function (params) {
                        if (params.isImage) {
                            logo_repository
                                .LogoRepository
                                .save(params.uuid)
                                .done(function (logo) {
                                    var img = {
                                        title: logo.title,
                                        id: logo.id,
                                        src: logo.resource_thumbnail,
                                    };

                                    imageWorker.set(img);
                                    addImgToList(nodes.getLogosContainer(), img);
                                    addImgToPreview(nodes.imgPreview, img);
                                    waitImg(logo.resource_thumbnail, function () {
                                        showPreview(nodes.imgPreview);
                                        progress.stop();
                                    })
                                });
                        }
                    });
                });

                let image = storage.getObj("conf-email-img");

                if (nodes.selectedImg) {
                    image = nodes.selectedImg.getAttribute("value");
                    image = JSON.parse(image);
                    setImg(image);
                }

                nodes.imgPreview.minusLogo.addEventListener("click", function () {
                    hidePreview(nodes.imgPreview);
                });

                nodes.imgPreview.openBtn.addEventListener('click', function () {
                    openUploadModal(uploadcare);
                });

                progress.stop();
            }

            // initialize logo picker
            uploader.initializeAndWaitUntilReady((uploadcare) => {
                uploaderCallback(uploadcare)
            });

            setDefaultLogo();
        },
        applySlider: (target, config) => {
            // used to control a slider element to match width and position of a clicked target
            // to indicate active state

            // loop through all slider targets and apply this function to each target
            // requires the following config to be passed in:
            /*
                parent: element - target wrapper,
                slider: element - slider bar/chip,
                callback: func - optional - callback function to execute after each click,
                padding: int - optional - add padding to slider width
                preventSlide: bool - optional - used to intercept slide action if necessary
            */

            let adjustSlider = (currentTarget) => {
                let parentPosition = config.parent.getBoundingClientRect();
                let targetPosition = currentTarget.getBoundingClientRect();

                if (config.padding) { // allow for padding on background sliders like chips
                    config.slider.style.width = `${targetPosition.width + (config.padding * 2)}px`;
                    config.slider.style.left = `${targetPosition.left - parentPosition.left - config.padding}px`;
                } else {
                    config.slider.style.width = `${targetPosition.width}px`;
                    config.slider.style.left = `${targetPosition.left - parentPosition.left}px`;
                }
            }

            target.addEventListener("click", (event) => {
                if (target.classList.contains("active")) {
                    config.slider.classList.add("bump");
                    setTimeout(() => {
                        config.slider.classList.remove("bump");
                    }, 300);
                } else {
                    if (config.callback) config.callback(event);
                }

                if(!config.preventSlide) {
                    config.parent.querySelector(".active").classList.remove("active");
                    target.classList.add("active");
                    adjustSlider(target);
                }
            });

            window.addEventListener("resize", () => {
                adjustSlider(config.parent.querySelector(".active"));
            });
        },
        getQueryStringVariable: (variable) => {
            let query = window.location.search.substring(1);
            let vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) == variable) {
                    return decodeURIComponent(pair[1]);
                }
            }
        },
        generateSentiment: (reviewType, reviewScore) => {
            if (reviewType === 'csat') {
                if (reviewScore === 1) return 'positive';
                if (reviewScore === 0) return 'neutral';
                if (reviewScore === -1) return 'negative';
            }

            if (reviewType === 'projects') {
                if (reviewScore < 3) return 'negative';
                if (reviewScore < 4) return 'neutral';
                if (reviewScore >= 4) return 'positive';
            }

            if (reviewType === 'nps') {
                if (reviewScore >= 9) return 'positive';
                if (reviewScore === 7 || reviewScore === 8) return 'neutral';
                if (reviewScore < 7) return 'negative';
            }
        },
        sanitizeData: (data) => {
            if(!data) return;
            
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
                '/': '&#x2F;',
                '`': '&#x60;',
                '=': '&#x3D;'
            };
            const reg = /[&<>"'/]/ig;

            let output = '';

            if(Array.isArray(data)) {
                output = [];
                data.forEach(item => {
                    output.push(item.replace(reg, (match)=>(map[match])));
                });
            } else {
                output = data.replace(reg, (match)=>(map[match]));
            }

            return output;
        },
        confirmationTooltip: (wrapperClassName, confirmCallback) => {
            // requires the following markup / css should be modified at page level:
            /*
            <div class="tooltip-wrap {{ wrapperClassName }}">
                <a class="icon remove glyphicons glyphicons-remove-sign"></a>
                <div class="sb-tooltip action">
                    Hover toggle text
                </div>
                <div class="sb-tooltip confirmation">
                    Confirmation toggle text (eg: Really delete?)
                    <div class="options">
                        <span class="confirm" data-id="${full.id}">Yes</span> // all data on confirm button is returned in confirmCallback
                        <span class="deny" data-id="${full.id}">No</span>
                    </div>
                </div>
            </div>`
            */
            document.querySelectorAll(`.${wrapperClassName}`).forEach(button => {
                button.addEventListener("click", (event) => {
                    document.querySelectorAll(".confirming").forEach(element => {
                        element.classList.remove("confirming");
                    })
                    event.currentTarget.classList.add("confirming");
                });
            });

            document.querySelectorAll(`.${wrapperClassName} .confirm`).forEach(button => {
                button.addEventListener("click", () => {
                    confirmCallback(button.dataset)
                });
            });

            document.querySelectorAll(".delete-user .deny").forEach(button => {
                button.addEventListener("click", () => {
                    document.querySelectorAll(`.confirming`).forEach(node => {
                        node.classList.remove("confirming");
                    });
                });
            });

            document.querySelector("body").addEventListener("click", (event) => {
                if(!event.target.classList.contains("icon") 
                    && !event.target.classList.contains("options") 
                    && !event.target.classList.contains("confirmation")
                    && !event.target.classList.contains(wrapperClassName)) {
                    document.querySelectorAll(".confirming").forEach(element => {
                        element.classList.remove("confirming");
                    })
                }
            })
        }
    }

    return utilities
});

